/*
 * @Description:
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2022-11-16 09:41:41
 * @LastEditors: Monkey
 * @LastEditTime: 2023-03-04 09:53:10
 */
//数据表格配置

import tool from '@/utils/tool';

export default {
  successCode: 0, //请求完成代码
  pageSize: 20, //表格每一页条数
  pageSizes: [10, 20, 30, 40, 50], //表格可设置的一页条数
  paginationLayout: 'total, sizes, prev, pager, next, jumper', //表格分页布局，可设置"total, sizes, prev, pager, next, jumper"
  columnDataKey: 'ajTable_column_',
  configDataKey: 'ajTable_config_',
  parseData: function (res) {
    //数据分析
    return {
      data: res.data, //分析无分页的数据字段结构
      rows: res.data.list, //分析行数据字段结构
      total: res.data.dataCount, //分析总数字段结构
      summary: res.data.summary || {}, //分析合计行字段结构
      msg: res.msg, //分析描述字段结构
      code: res.code, //分析状态字段结构
    };
  },
  request: {
    //请求规定字段
    page: 'page', //规定当前分页字段
    pageSize: 'pageSize', //规定一页条数字段
    prop: 'orderColumn', //规定排序字段名字段
    order: 'orderDirection', //规定排序规格字段
  },
  /**
   * 自定义列保存处理
   * @tableName scTable组件的props->tableName
   * @column 用户配置好的列
   */
  columnSettingSave: function (tableName, column) {
    return new Promise((resolve) => {
      tool.data.set(this.columnDataKey + tableName, column);
      resolve(true);
    });
  },
  /**
   * 获取自定义列
   * @tableName scTable组件的props->tableName
   * @column 组件接受到的props->column
   */
  columnSettingGet: function (tableName, column) {
    return new Promise((resolve) => {
      //这里为了演示使用了session和setTimeout演示，开发时应用数据请求
      const userColumn = tool.data.get(this.columnDataKey + tableName);
      if (userColumn) {
        resolve(userColumn);
      } else {
        resolve(column);
      }
    });
  },
  /**
   * 重置自定义列
   * @tableName scTable组件的props->tableName
   * @column 组件接受到的props->column
   */
  columnSettingReset: function (tableName, column) {
    return new Promise((resolve) => {
      //这里为了演示使用了session和setTimeout演示，开发时应用数据请求
      setTimeout(() => {
        tool.data.remove(this.columnDataKey + tableName);
        resolve(column);
      }, 1000);
    });
  },

  /**
   * @description: 保存自定义设置
   * @param {*} tableName 表名
   * @param {*} config 设置
   * @return {*}
   */
  configSettingSave: function (tableName, config) {
    return new Promise((resolve) => {
      tool.data.set(this.configDataKey + tableName, config);
      resolve(true);
    })
  },
  /**
   * @description: 保存自定义设置
   * @param {*} tableName 表名
   * @param {*} config 未获取到自定义设置时默认值
   * @return {*}
   */
  configSettingGet: function (tableName, config) {
    return new Promise((resolve) => {
      const tableConfig = tool.data.get(this.configDataKey + tableName);
      if (tableConfig) {
        resolve(tableConfig);
      } else {
        resolve(config);
      }
    })
  }
};
